import React from 'react'

import { Box, Tab, Tabs } from '@mui/material'

import { VerticalTabPanel } from 'components/common'
import { DynamicEmailTemplateType } from 'generated/graphql'

import { EmailBoxSx, EmailTabSx } from '../SettingsStyles'
import { EmailTemplateMapping } from './EmailTemplateMapping'

enum TabId {
  CustomerDelay = 0,
  ProofOfCollection = 1,
  Delivered = 2,
  BookingCancelled = 3,
  ConsignmentDelivered = 4,
  FinalDeliveryArrival = 5,
  DeliveryArrival = 6,
  ConsignmentCollected = 7,
  CollectionArrival = 8,
  BookingUpdated = 9,
  DriverAllocated = 10,
  BookingConfirmation = 11,
  NewAvailableBookings = 12,
  DriverAccountConfirmationOwner = 13,
  DriverAccountConfirmationSubDriver = 14,
  DriverAccountApprovedOwner = 15,
  DriverAccountApprovedSubDriver = 16,
  DriverAccountNotApproved = 17,
  PasswordReset = 18,
  DriverAccountUnblocked = 19,
  DriverAccountBlocked = 20,
}

function commonProps(index: TabId) {
  return {
    id: `email-template-tab-${index}`,
    'aria-controls': `email-template-tabpanel-${index}`,
  }
}

const DynamicEmailTemplates = () => {
  const [tabValue, setTabValue] = React.useState(0)

  const tabs = [
    {
      id: TabId.CustomerDelay,
      label: 'Customer Delay',
      type: DynamicEmailTemplateType.CustomerDelay,
    },
    {
      id: TabId.ProofOfCollection,
      label: 'Proof Of Collection',
      type: DynamicEmailTemplateType.ProofOfCollection,
    },
    {
      id: TabId.Delivered,
      label: 'Delivered',
      type: DynamicEmailTemplateType.Delivered,
    },
    {
      id: TabId.BookingCancelled,
      label: 'Booking Cancelled',
      type: DynamicEmailTemplateType.BookingCancelled,
    },
    {
      id: TabId.ConsignmentDelivered,
      label: 'Consignment Delivered',
      type: DynamicEmailTemplateType.ConsignmentDelivered,
    },
    {
      id: TabId.FinalDeliveryArrival,
      label: 'Final Delivery Arrival',
      type: DynamicEmailTemplateType.FinalDeliveryArrival,
    },
    {
      id: TabId.DeliveryArrival,
      label: 'Delivery Arrival',
      type: DynamicEmailTemplateType.DeliveryArrival,
    },
    {
      id: TabId.ConsignmentCollected,
      label: 'Consignment Collected',
      type: DynamicEmailTemplateType.ConsignmentCollected,
    },
    {
      id: TabId.CollectionArrival,
      label: 'Collection Arrival',
      type: DynamicEmailTemplateType.CollectionArrival,
    },
    {
      id: TabId.BookingUpdated,
      label: 'Booking Updated',
      type: DynamicEmailTemplateType.BookingUpdated,
    },
    {
      id: TabId.DriverAllocated,
      label: 'Driver Allocated',
      type: DynamicEmailTemplateType.DriverAllocated,
    },
    {
      id: TabId.BookingConfirmation,
      label: 'Booking Confirmation',
      type: DynamicEmailTemplateType.BookingConfirmation,
    },

    {
      id: TabId.NewAvailableBookings,
      label: 'New Available Bookings',
      type: DynamicEmailTemplateType.NewAvailableBookings,
    },
    {
      id: TabId.DriverAccountConfirmationOwner,
      label: 'Driver Account Confirmation - Owner',
      type: DynamicEmailTemplateType.DriverAccountConfirmationOwner,
    },
    {
      id: TabId.DriverAccountConfirmationSubDriver,
      label: 'Driver Account Confirmation - Sub-driver',
      type: DynamicEmailTemplateType.DriverAccountConfirmationSubDriver,
    },
    {
      id: TabId.DriverAccountApprovedOwner,
      label: 'Driver Account Approved - Owner',
      type: DynamicEmailTemplateType.DriverAccountApprovedOwner,
    },
    {
      id: TabId.DriverAccountApprovedSubDriver,
      label: 'Driver Account Approved - Sub-driver',
      type: DynamicEmailTemplateType.DriverAccountApprovedSubDriver,
    },
    {
      id: TabId.DriverAccountNotApproved,
      label: 'Driver Account Not Approved',
      type: DynamicEmailTemplateType.DriverAccountNotApproved,
    },
    {
      id: TabId.PasswordReset,
      label: 'Password Reset',
      type: DynamicEmailTemplateType.PasswordReset,
    },
    {
      id: TabId.DriverAccountUnblocked,
      label: 'Driver Account Unblocked',
      type: DynamicEmailTemplateType.DriverAccountUnblocked,
    },
    {
      id: TabId.DriverAccountBlocked,
      label: 'Driver Account Blocked',
      type: DynamicEmailTemplateType.DriverAccountBlocked,
    },
  ]

  const handleChange = (_, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Box sx={EmailBoxSx}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        orientation='vertical'
        aria-label='email template tabs'
        variant='scrollable'
        sx={EmailTabSx}>
        {tabs.map((tab) => (
          <Tab label={tab.label} key={tab.id} {...commonProps(tab.id)} />
        ))}
      </Tabs>

      {tabs.map((tab) => (
        <VerticalTabPanel value={tabValue} index={tab.id} key={tab.id} px={3}>
          <EmailTemplateMapping type={tab.type} label={tab.label} />
        </VerticalTabPanel>
      ))}
    </Box>
  )
}

export default DynamicEmailTemplates
